import { Pipe, PipeTransform } from '@angular/core';
import { MonthName } from '@app/shared/enums/month-names.enum';
import { getMonth, isValid } from 'date-fns';

@Pipe({
  name: 'monthNameKeyFromDate'
})
export class MonthNameTranslationKeyFromDate implements PipeTransform {
  transform(value: Date | string): string {
    const date = new Date(value);
    if (!isValid(date)) {
      return '';
    }

    const monthId = getMonth(date) + 1;
    return `SHARED.MONTHS-ABBREV.${MonthName[monthId]}`.toUpperCase();
  }
}
